module.exports = __webpack_public_path__ + "img/students.149163e3.png";